import { useRef } from "react";

import ticker from "../media/ticker.png";
import chain from "../media/chain.png";
import supply from "../media/supply.png";
import contractIcon from "../media/contract.png";
import copyIcon from "../media/copy.png";

const contract =
    "GvgpSZJm2veVCLhWdwYVu3WSSVAXqyt6YcvWkyakpump";

const shortContract = `${contract.slice(0, 4)}...${contract.slice(-4)}`;

function TokenInfo() {

    const toastRef = useRef(null);

    const copyContract = async () => {

        try {

            if (navigator.clipboard && window.isSecureContext) {

                await navigator.clipboard.writeText(contract);

            } else {

                const textArea = document.createElement("textarea");
                textArea.value = contract;
                textArea.style.position = "fixed";
                textArea.style.left = "-9999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);

            }

            window.bootstrap.Toast.getOrCreateInstance(
                toastRef.current
            ).show();

        } catch (err) {

            console.log(err);

        }

    };

    return (

        <section className="token-info" id="token">

            <div className="container">

                <div className="token-box">

                    <h2>TOKEN INFO</h2>

                    <div className="row g-0 align-items-center">

                        {/* Ticker */}

                        <div className="col-md-3">

                            <div className="token-item">

                                <img src={ticker} alt="" />

                                <div>

                                    <small>TICKER</small>

                                    <h4>$TUBE</h4>

                                </div>

                            </div>

                        </div>

                        {/* Chain */}

                        <div className="col-md-3">

                            <div className="token-item">

                                <img src={chain} alt="" />

                                <div>

                                    <small>CHAIN</small>

                                    <h4>SOLANA</h4>

                                </div>

                            </div>

                        </div>

                        {/* Supply */}

                        <div className="col-md-3">

                            <div className="token-item">

                                <img src={supply} alt="" />

                                <div>

                                    <small>SUPPLY</small>

                                    <h4>1,000,000,000</h4>

                                </div>

                            </div>

                        </div>

                        {/* Contract */}

                        <div className="col-md-3">

                            <div className="token-item contract-item">

                                <img src={contractIcon} alt="" />

                                <div className="contract-text">

                                    <small>CONTRACT</small>

                                    <p>{shortContract}</p>

                                </div>

                                <button
                                    className="copy-btn"
                                    onClick={copyContract}
                                >

                                    <img src={copyIcon} alt="" />

                                    <span>COPY</span>

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            {/* Toast */}

            <div
                className="toast position-fixed bottom-0 end-0 m-4"
                role="alert"
                data-bs-delay="1800"
                ref={toastRef}
            >

                <div className="toast-body fw-bold">

                    ✅ Contract copied!

                </div>

            </div>

        </section>

    );

}

export default TokenInfo;